import { LOADING, FAILED, SUCCESS, ACTION } from './constants';
import {
  listAreaManagement,
  postAreaManagement,
  putAreaManagement,
  deleteAreaManagement,
} from '../../utils/api';

export function fetchAreaManagement(page = 1, search = '') {
  return async (dispatch, getState) => {
    const state = getState();
    const KEY = 'AreaManagement';
    let dataList  = [];
    const { totalPage } = state.areaManagement.dataAreaManagement.meta;
    if (page !== 1 && page >= totalPage) {
      return;
    }
    try {
      if (page !== 1 && page !== '1') {
        dataList = state.areaManagement.dataAreaManagement.data;
      }
      dispatch(loadingAction(true, KEY));
      const params = { search, page: page, size: 100 };
      const { data, meta } = await listAreaManagement(params);
      dispatch(successAction({ data: [ ...dataList, ...data] , meta }, KEY));
    } catch (error) {
      dispatch(failedAction(error.message, KEY));
    }
  };
}

export function createAreaManagement(value) {
  return async (dispatch) => {
    const key = 'SubmitAreaManagement';
    dispatch(loadingAction(true, key));
    try {
      const payload = {
        code: value.code,
        name: value.name,
      };
      await postAreaManagement(payload);
      dispatch(successAction(false, 'SubmitUpdateAreaManagement', ''));
      dispatch(successAction(true, key));
    } catch (error) {
      dispatch(successAction(false, 'SubmitUpdateAreaManagement', ''));
      dispatch(failedAction(error.message, key));
    }
  };
}

export function editAreaManagement(value) {
  return async (dispatch) => {
    const key = 'SubmitUpdateAreaManagement';
    dispatch(loadingAction(true, key));
    try {
      const payload = {
        code: value.code,
        name: value.name,
      };
      await putAreaManagement(value.id, payload);
      dispatch(successAction(false, 'SubmitAreaManagement', ''));
      dispatch(successAction(true, key));
    } catch (error) {
      dispatch(successAction(false, 'SubmitAreaManagement', ''));
      dispatch(failedAction(error.message, key));
    }
  };
}

export function removeAreaManagement(id) {
  return async (dispatch) => {
    const key = 'SubmitUpdateAreaManagement';
    dispatch(loadingAction(true, key));
    try {
      await deleteAreaManagement(id);
      dispatch(successAction(false, 'SubmitAreaManagement'));
      dispatch(successAction(true, key));
    } catch (error) {
      dispatch(successAction(false, 'SubmitAreaManagement'));
      dispatch(failedAction(error.message, key));
    }
  };
}

export function failedAction(message, key) {
  return { type: FAILED, message, key };
}

export function loadingAction(isLoading, key) {
  return { type: LOADING, isLoading, key };
}

export function successAction(data, key, message) {
  return { type: SUCCESS, data, key, message: message };
}

export function setAction(data) {
  return { type: ACTION, data };
}
